import { runInAction } from "mobx";
import { loaderState } from "./event-loader.js";

(function () {
  const roomSwitchers = document.querySelectorAll(".js-multiroom-toggle");
  if (!roomSwitchers.length) return;

  const showLoader = () => runInAction(() => (loaderState.showLoader = true));

  let i;
  for (i = 0; i < roomSwitchers.length; ++i) {
    roomSwitchers[i].addEventListener("change", (e) => {
      showLoader();
      // ? safari won't show the loader if href changed immediately, push to next frame
      requestAnimationFrame(() => (location.href = e.target.value));
    });
  }
})();
